import React from "react";
import Categories from "./Categories/Categories";
import Region from "./Region/Region";
import ListingType from "./ListingType/ListingType";
import Make from "./Make/Make";
import BodyStyle from "./BodyStyle/BodyStyle";
import FuelType from "./FuelType/FuelType";
import Doors from "./Doors/Doors";
import Transmission from "./Transmission/Transmission";
import Color from "./Color/Color";
import Condition from "./Condition/Condition";
import SellerType from "./SellerType/SellerType";
import Search from "./Search/Search";
import MilageAndYear from "./MilageAndYear/MilageAndYear";
import BlockTitle from "../../Shared/BlockTitle/BlockTitle";

const Filter = () => {
  return (
    <div className="w-1/4">
      <BlockTitle text="Filter" />
      <ListingType />
      <Region />
      <Categories />
      <Make />
      <BodyStyle />
      <MilageAndYear />
      <FuelType />
      <Doors />
      <Transmission />
      <Color />
      <Condition />
      <SellerType />
      <Search />
    </div>
  );
};

export default Filter;
